// import type { IExamAttemptsQuestionDto } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IInteractiveExamAttemptResponse } from "@api/courses/exams/interactive/attempts/types";

const postApis = createPostApi<
  IApiResponse<IInteractiveExamAttemptResponse>,
  IPathBaseParam,
  undefined
>(
  "courses.exams.interactive.interactiveExamAttempt.interactiveExamFinishAttempt",
);

export const interactiveExamFinishAttempt = {
  ...postApis,
};
